import { api } from "../api";
import { backendErrors, overrideFieldError } from "./common";

export const webTrader = async (data: any) => {
  const { data: response } = await api.forms.registerLeadWithDemo(data);

  if (response.errors || !response.success) {
    const errors = overrideFieldError(
      response.errors,
      "email",
      "unknown_error"
    );
    throw { errors: backendErrors(errors || {}) };
  }

  return {
    data: response
  };
};
